import React, { FC, useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress, Grid, Tooltip } from '@mui/material';
import { httpRequest } from 'src/services/httpRequest';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import CustomTable from 'src/ui-component/CustomTable/Index';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
interface Props {
  applicationDetails: any;
}

const PaymentHistory: FC<Props> = ({ applicationDetails }) => {
  const { applicationID } = applicationDetails || {};
  const [loading, setLoading] = useState<boolean>(false);
  const { permit } = useParams();
  const userData = useSelector((store: RootState) => store.user.userDetails);
  const currentPermitRole = useSelector(
    (state: RootState) =>
      state?.currentPermit?.currentPermitDetails?.currentPermitUserRole
  );
  const isManagerOrAdmin =
    currentPermitRole === 'Manager' ||
    userData?.UserRole === 'Admin' ||
    userData?.UserRole === 'Super Admin';

  const [paymentHistory, setPaymentHistory] = useState<any>({
    columns: isManagerOrAdmin
      ? ['Fee Type', 'Date', 'Transaction', 'Payment Via', 'Amount']
      : ['Fee Type', 'Date', 'Transaction', 'Amount', 'Action'],
    rows: []
  });

  //Method to get payment history
  const handleGetPaymentHistory = async () => {
    setLoading(true);
    const response = await httpRequest(
      'GET',
      `/payments/getPaymentDetails/${permit}/${applicationID}`
    );
    if (response.status === 'success') {
      const data = response?.data?.paymentDetails?.map((item: any) => {
        return {
          FeeType: item?.PermitFeeType || '-',
          date: format(new Date(item?.InsertDate), 'MM/dd/yyyy'),
          Transaction: item?.TransactionNumber || 'Payment Due',
          ...(isManagerOrAdmin && {
            PaymentVia: item?.PaymentType || '-'
          }),
          Amount: `$${item?.TotalAmount || 0.0}`,
          ...(!isManagerOrAdmin && {
            Action: item?.TransactionNumber ? (
              <>
                <Tooltip title="View Transaction History" arrow>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${item.ejsUrl}`}
                  >
                    <IconButton
                      color="inherit"
                      disabled={!item?.TransactionNumber}
                      size="small"
                    >
                      <VisibilityIcon color="primary" fontSize="small" />
                    </IconButton>
                  </a>
                </Tooltip>
              </>
            ) : (
              <Tooltip title="Proceed To Payment" arrow>
                <IconButton color="inherit" size="small">
                  <InfoOutlinedIcon color="info" fontSize="small" />
                </IconButton>
              </Tooltip>
            )
          })
        };
      });
      setPaymentHistory({ ...paymentHistory, rows: data });
    } else if (response.type === 'NETWORK_ERROR') {
    } else {
      toast.error(response?.message || 'Something went wrong');
    }
    setLoading(false);
  };

  useEffect(() => {
    handleGetPaymentHistory();
  }, []);

  return (
    <React.Fragment>
      <Grid container gap={2} mt={2} justifyContent={'space-between'}>
        <Grid
          item
          md={6}
          xs={12}
          sm={12}
          display={'flex'}
          alignItems={'center'}
        >
          <Typography variant="h3" fontSize={'22px'} color={'#6E759F'}>
            Payment History
          </Typography>
        </Grid>
      </Grid>
      <Box mt={2}>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 100
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            {paymentHistory?.rows?.length ? (
              <>
                <CustomTable
                  pagination={0}
                  setSelectedRowData={''}
                  rows={paymentHistory?.rows}
                  columns={paymentHistory.columns}
                  isSearch={false}
                />
              </>
            ) : (
              <Typography fontSize={14} textAlign={'center'} mt={15}>
                Payment history is not available for the specified application.
              </Typography>
            )}
          </>
        )}
      </Box>
    </React.Fragment>
  );
};

export default PaymentHistory;
